

import React, { useContext, useEffect, useState } from 'react'



import { TransactionsContext } from '../../context/transactions/TransactionContext';
import TransactionDetail from '../../components/ui/TransactionDetail';
import Paginator from '../../components/ui/Paginator';

import DateRangePicker from 'react-bootstrap-daterangepicker';
import 'bootstrap-daterangepicker/daterangepicker.css';
import moment from 'moment';
import { AuthContext } from '../../context/auth';
import { MerchantsContext } from '../../context/merchants/MerchantContext';


 

export const TransactionPage = () => {
    const [buscar, setBuscar] = useState('');
    const [pageActual, setPageActual] = useState<number>(1);    
    const [merchantId, setMerchantId] = useState(-1);
    const { transactions, totalPage, loadTransactions, isLoading } = useContext(TransactionsContext);
    const {user} = useContext(AuthContext);
    const {merchants, loadMerchants} = useContext(MerchantsContext);
   
    const [dateIni, setDateIni] = useState('');
    const [dateEnd, setDateEnd] = useState('');
    const [transactionId, setTransactionId] = useState(-1);

   
    useEffect(() => {
        loadMerchants(0);
    }, [])
   
    useEffect(() => {
        if(!dateIni)
            setDateIni(moment().format("YYYY-MM-DD"))

        if(!dateEnd)
            setDateEnd(moment().add(1, 'day').format("YYYY-MM-DD"))
       
    }, [])
    
    useEffect(() => {
        if(dateIni.length > 0)
            loadTransactions(pageActual - 1, dateIni, dateEnd, merchantId, transactionId);
    }, [pageActual])

   
   
    const filteredData = transactions.filter((transaction) =>
        transaction.transaction_id.toString().toLowerCase().includes(buscar.toLowerCase())
    );

    const handleFilter = () => {
        const page = transactionId > 0 ? 1 : pageActual

        loadTransactions(page - 1, dateIni, dateEnd, merchantId, transactionId);
        if (transactionId > 0)
            setPageActual(1)
        
    }

    const handleSelect = ({ target }) => {
        var { value } = target;
        setMerchantId(value);
    }

    const handleCallback = (start, end) => {
        setDateIni(start.format('YYYY-MM-DD'));
        setDateEnd(end.format('YYYY-MM-DD'));
    }

    const onInputChange = ({ target }) => {
        var { value } = target;
        setTransactionId(value);
    } 

    

    return (
        
        <div className='mt-5 container' style={ styles.container }>
            <div>
                <div className='row' >

                    <div className=' col-md-4' >
                        <DateRangePicker
                        onCallback={handleCallback}
                        initialSettings={{ 
                            locale: {
                                cancelLabel: 'Cancelar',
                                applyLabel: 'Aplicar',
                                customRangeLabel: 'Seleccionar fechas'
                                },
                            startDate: moment(), 
                            minDate: moment().subtract(1, "year"),
                            maxDate : moment(),
                            ranges: {
                                'Hoy': [moment(), moment()],
                                'Ayer': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
                                'Esta semana': [moment().startOf('week'), moment().endOf('week')],
                                'Este mes': [moment().startOf('month'), moment()],
                                'Últimos 7 días': [moment().subtract(6, 'days'), moment()],
                                'Último 30 días': [moment().subtract(30, 'days'), moment()],
                                
                              }
                        }}
                        >
                            <input type="text" className="form-control"  />
                        </DateRangePicker>
                    </div>
                    {
                        user.groups[0].group_name.toLowerCase() == "backoffice"
                        || user.groups[0].group_name.toLowerCase() == "administrator"  
                        ? (
                            <div className="col-md-4">
                           
                            <select id='merchantSelect' className="form-select"  name="group_id" onChange={handleSelect} >
                            
                            {
                                merchants?.length > 0 
                                ?
                                <>
                                    <option key={0} value={-1} >Todos los comercios</option>
                                    { 
                                        merchants.map(merchant => (
                                            <option key={merchant.merchant_id} value={merchant.merchant_id} >{merchant.merchant_name}</option>
                                        ))
                                    }
                                </>
                                
                                :
                                 <option selected>No hay comercios disponibles</option>
                            }
                           </select>
                        </div>
                          )
                        : (<div  className='col-md-1' style={{width: '0px !important'}}/>) 
                    }
                    <div className=' col-md-3' >
                    <input 
                        id='transactionIdInput'
                        type="number" 
                        className={`form-control`}
                        placeholder="Número transacción"
                        name="transactionId"
                        min="0"
                        onChange={ onInputChange }
                    />
                    </div>
                    <div className='col-md-1' >
                        <button className='btn btn-primary' style={{width: '100%'}} onClick={handleFilter}> Filtrar</button>
                    </div> 
                </div>
                
                

            </div>

            <div className="row justify-content-end mt-5">
                <div className=' col-md-3' style={{position: 'revert'}}>
                    <input className="form-control" id="search" type="text" placeholder="Buscar" value={buscar}  onChange={(e) => setBuscar(e.target.value)}/> 
                </div>
            </div>
            <br></br>
            <table id='transactionTable' className="table table-hover table-striped">
                <thead className="thead-dark">
                    <tr>
                        
                        <th>Transacción</th>
                        <th>Auth.</th>
                        <th>Monto</th>
                        <th>Fecha</th>                        
                        <th>Tipo tarjeta</th>
                        <th>Tarjeta</th>
                        <th>Tipo Transacción</th>
                        <th>Terminal</th>
                        <th>Comercio</th>
                        <th>Usuario</th>
                    </tr>
                </thead>
                <tbody >
                {
                    isLoading 
                    ?
                    <tr> <td colSpan={10} className='text-center'>Cargando...</td></tr>
                    :
                    filteredData.length > 0 
                    ?
                    filteredData.map(transaction => (
                        transaction ? <TransactionDetail key={transaction.id}  {...transaction} /> : null
                      ))
                    :
                    <tr> <td colSpan={10} className='text-center'>No existen transacciones.</td></tr>
                }
                
                
                </tbody>
            </table>    
            
            {
                totalPage > 1 ?  <Paginator totalPage={totalPage} pageActual={pageActual} onChange={(actual)=> setPageActual(actual)} />   : <div />
            }
              
           
            
            
            

        </div>
    )
}


const styles = {
    container: {
        flex:1,
        marginTop: 10,
        marginHorizontal: 20
    }
};
